import { Navigate, useSearchParams } from "react-router";
import { useAuth } from "@/lib/auth";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { JobsTab } from "./jobs-tab";
import { CronTab } from "./cron-tab";
import { EventsTab } from "./events-tab";
import { FurstImportTab } from "./furst-import-tab";
import { GarminTab } from "./garmin-tab";
import { LiveTab } from "./live-tab";
import { ConversionsTab } from "./conversions-tab";
import { ApiKeysTab } from "./api-keys-tab";

const VALID_TABS = [
  "live",
  "jobs",
  "cron",
  "events",
  "furst-import",
  "garmin",
  "conversions",
  "api-keys",
];

export function SystemPage() {
  const { hasRole } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") ?? "";
  const activeTab = VALID_TABS.includes(tabFromUrl) ? tabFromUrl : "live";

  if (!hasRole("superuser")) {
    return <Navigate to="/dashboard" replace />;
  }

  // Oversikt and Logger moved to Overvåking; keep old bookmarks working.
  if (tabFromUrl === "overview") {
    return <Navigate to="/monitoring?tab=infra" replace />;
  }
  if (tabFromUrl === "logs") {
    const next = new URLSearchParams(searchParams);
    next.set("tab", next.get("view") === "raa" ? "raa" : "feil");
    next.delete("view");
    return <Navigate to={`/monitoring?${next}`} replace />;
  }

  const handleTabChange = (value: string) => {
    const params = new URLSearchParams(searchParams);
    params.set("tab", value);
    setSearchParams(params, { replace: true });
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">System</h2>
      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="live">Live</TabsTrigger>
          <TabsTrigger value="jobs">Jobber</TabsTrigger>
          <TabsTrigger value="cron">Cron</TabsTrigger>
          <TabsTrigger value="events">Events</TabsTrigger>
          <TabsTrigger value="furst-import">Furst Import</TabsTrigger>
          <TabsTrigger value="garmin">Garmin</TabsTrigger>
          <TabsTrigger value="conversions">Konverteringer</TabsTrigger>
          <TabsTrigger value="api-keys">API-nøkler</TabsTrigger>
        </TabsList>
        <TabsContent value="live">
          <LiveTab />
        </TabsContent>
        <TabsContent value="jobs">
          <JobsTab />
        </TabsContent>
        <TabsContent value="cron">
          <CronTab />
        </TabsContent>
        <TabsContent value="events">
          <EventsTab />
        </TabsContent>
        <TabsContent value="furst-import">
          <FurstImportTab />
        </TabsContent>
        <TabsContent value="garmin">
          <GarminTab />
        </TabsContent>
        <TabsContent value="conversions">
          <ConversionsTab />
        </TabsContent>
        <TabsContent value="api-keys">
          <ApiKeysTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
